// initial state
const state = {
  identity: null,
  investigation: null,
  approved: null,
  macroStats: {}, // Keyed by username
  macroDetails: [],
  error: 0
}

// getters
const getters = {
  identityConnections: state => state.identity,
  allConnections: state => state.identity,
  investigationConnections: state => state.investigation,
  approvedDevices: state => state.approved,
  macroStats: state => state.macroStats,
  macroDetails: state => state.macroDetails,
  connectionError: state => state.error
}

// actions
const actions = {
  getIdentity ({ commit }, data) {
    commit('setIdentity', data.data)
  },
  getConnections ({ commit }, data) {
    commit('setConnections', data.data)
  },
  getInvestigation ({ commit }, data) {
    commit('setInvestigation', data.data.partners)
    if (data.data.target_macros) {
        commit('setMacroStats', data.data.target_macros)
    }
  },
  getApprovedDevices ({ commit }, data) {
    commit('setApprovedDevices', data.data)
  },
  getMacroStats ({ commit }, data) {
    commit('setMacroStats', data.data)
  },
  getMacroDetails ({ commit }, data) {
    commit('setMacroDetails', data.data)
  },
  setError ({commit}, data) {
    commit('setError', data.data)
  }
}

import Vue from 'vue'

// mutations
const mutations = {
  setIdentity (state, data) {
    state.identity = data
  },
  setConnections (state, data) {
    state.identity = data
  },
  setInvestigation (state, data) {
    if (!data) {
      state.investigation = null
      return
    }
    state.investigation = data
  },
  setApprovedDevices (state, devices) {
    state.approved = devices
  },
  setMacroStats (state, data) {
    if (!data) {
       state.macroStats = {}; // Clear all
       return;
    }
    // Update specific user in the map
    Vue.set(state.macroStats, data.username, data);
  },
  setMacroDetails (state, data) {
    state.macroDetails = data
  },
  setError (state, error) {
    state.error = {error: error, time: Date.now()}
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
